import { JSX } from 'react'
import { AiFillEdit } from 'react-icons/ai'
import { CiSearch } from 'react-icons/ci'
import { NavigateFunction } from 'react-router-dom'

import { PrepaidVoucher } from '../api/services/dd_panel_prepaid_vouchers/types.ts'
import { Action } from '../components/common/Table/Table.tsx'

type TableColumn = {
  header: string
  accessor: string
  render?: (data: PrepaidVoucher) => JSX.Element
  className?: string
  classNameTd?: string
  sorted?: boolean
}

export const setPrepaidVouchersTableColumns = () => {
  const columns: TableColumn[] = [
    {
      header: 'Długość diety',
      accessor: 'diet_length',
      render: (row: PrepaidVoucher) => (
        <p className={'text-xm'}>
          {row.diet_length * 30}
          {' dni'}
        </p>
      ),
      className: 'w-[150px] 2xl:w-auto'
    },
    {
      header: 'Użyta',
      accessor: 'order',
      render: (row: PrepaidVoucher) => (
        <p className={'text-xm'}>
          {row.order ? `TAK - nr zam. ${row.order}` : 'NIE'}
        </p>
      ),
      className: 'w-[150px] 2xl:w-auto'
    }
  ]

  return columns
}

export const setPrepaidVouchersTableActions = (
  navigate: NavigateFunction,
  formActivated: boolean,
  editVoucher: PrepaidVoucher | null,
  setEditVoucher: React.Dispatch<React.SetStateAction<PrepaidVoucher | null>>
) => {
  const actions: Action<PrepaidVoucher>[] | undefined = []

  actions.push({
    label: 'Przejdź do zamówienia',
    icon: <CiSearch className="text-lg" />,
    onClick: (row: PrepaidVoucher) => {
      navigate(`/orders/${row.order}/`)
    },
    className: 'text-blue-500',
    visible: (row: PrepaidVoucher) => {
      return row.order !== null && editVoucher === null && !formActivated
    }
  })

  actions.push({
    label: 'Edytuj',
    icon: <AiFillEdit className="text-lg" />,
    onClick: (row: PrepaidVoucher) => setEditVoucher(row),
    className: 'text-blue-500 m-auto',
    visible: (row: PrepaidVoucher) => {
      return row.order === null && editVoucher === null && !formActivated
    }
  })

  actions.push({
    label: 'Edytowany...',
    icon: <AiFillEdit className="text-lg" />,
    onClick: (row: PrepaidVoucher) => setEditVoucher(row),
    className: 'text-green-500 m-auto',
    visible: (row: PrepaidVoucher) => {
      return row.id === editVoucher?.id
    }
  })

  return actions
}
